import { SELECT_ASSETS } from './actions'

export const SCREENS = {
  show: 'show',
  checkingConsentRequirement: 'checkingConsentRequirement',
  consent: 'consent',
  consentFailed: 'consentFailed',
  consentGranted: 'consentGranted',
  failed: 'failed',
  report: 'report',
}

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case SELECT_ASSETS:
      return {
        ...state,
        selectedAssets: payload.selectedAssets,
      }
    default:
      return { ...state }
  }
}

const screenForAstuteRequestState = {
  pending: SCREENS.show,
  checking_digital_consent_requirement: SCREENS.checkingConsentRequirement,
  awaiting_digital_consent: SCREENS.consent,
  digital_consent_granted: SCREENS.consentGranted,
  digital_consent_not_granted: SCREENS.consentFailed,
  failed: SCREENS.failed,
  complete: SCREENS.report,
}

export const propsToState = (props) => {
  return {
    authenticityToken: props.authenticityToken,
    lastUpdated: props.lastUpdated,
    client: props.client,
    holdings: props.holdings ? props.holdings.map((h, i) => {
      /* setting unique index ensures toggleAssetSelected fn is always dealing
       * with unique asset objects even when key/values are identical */
      h.index = i
      return h
    }) : null,
    astuteRequest: props.astuteRequest,
    lastServiceRequest: props.lastServiceRequest,
    tenantSlug: props.tenantSlug,
    view: screenForAstuteRequestState[props.astuteRequest.status],
    assetTypeMapping: props.assetTypeMapping,
    paths: props.paths,
    selectedAssets: [],
  }
}
